/**
 * HyperDX Ingestion Endpoint 설정
 *
 * PRIMARY: 직접 연결 (저렴)
 * FALLBACK: 프록시 경유 (과금) - 방화벽으로 PRIMARY 차단 시 사용
 */

export const ENDPOINTS = {
  PRIMARY: 'https://ingestion.zep.us',
  FALLBACK: 'https://zep.us/ingestion',
} as const;

const HEALTH_CHECK_TIMEOUT_MS = 10000;

/**
 * PRIMARY endpoint에 health check 후 사용할 endpoint를 결정합니다.
 * - 서버에 도달 가능하면 (4xx 포함) PRIMARY 사용
 * - 네트워크 에러/타임아웃 (방화벽 차단) 시 FALLBACK 사용
 */
export async function resolveEndpoint(): Promise<string> {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(
      () => controller.abort(),
      HEALTH_CHECK_TIMEOUT_MS,
    );

    await fetch(`${ENDPOINTS.PRIMARY}/v1/traces`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: '{}',
      signal: controller.signal,
    });

    clearTimeout(timeout);
    return ENDPOINTS.PRIMARY;
  } catch {
    return ENDPOINTS.FALLBACK;
  }
}
